<div>
	<a class="Hashtag"
		*ngFor="let tag of section.UF_FILTER_TAGS"
		[routerLink]="['/catalog/section/', section.CODE, tag.CODE]"
		routerLinkActive="Hashtag--active" [routerLinkActiveOptions]="{exact: true}"
		>{{ tag.NAME }}
	</a>
</div>
